import dynamic from "next/dynamic";

import { useGetDeviceType } from "_common/hooks/global";
import { useGetAdConfig }   from "_common/hooks/global";
import { useGetDarkMode }   from "_common/hooks/global";

const AdSlot        = dynamic ( () => import ( "_components/features/ads/slot/single" ) );
const Advertisement = dynamic ( () => import ( "_components/features/ads/bannerMobile" ) );

const component = () => {
	const { VIDEO_PLAYER_COMPANION_MWEB: config } = useGetAdConfig ();
	const darkMode                                = useGetDarkMode ();
	const deviceType                              = useGetDeviceType ();
	const isMobile                                = deviceType === "mobile";

	if ( !config?.enabled || !isMobile )
		return null;

	if ( config?.adManager === "vmax" )
		return (
			<Advertisement id = { config?.adUnitId } />
		);

	const path = darkMode ? config?.slotId?.dark : config?.slotId?.light;

	return (
		<AdSlot
			id    = { "gpt-passback" }
			index = { "below-player" }
			path  = { path }
			size  = { config?.size }
		/>
	);
};

export default component;
